import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import EdfiWriterForm from '../forms/edfi-writer-form';
import { edfiWriterValidationSchema } from '../schema/edfiWriter.js';

export default function EdfiWriterNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'EDFI Writer Node Details',
        altText: 'EDFI Writer Node',
        defaultLabel: 'EDFI Writer Node',
      }}
    >
      <CommonNode FormComponent={EdfiWriterForm} schemaResolver={edfiWriterValidationSchema} />
    </NodeProvider>
  );
}
